// src/api/user.ts
import ApiService from "@/utils/request";
export const lcgApi = {
    // 部门数量接口
    deptUse: (params) => ApiService.get("/lcg/datav/depts", params),
    // 低耗占比比例图接口
    useProportion: () => ApiService.get("/lcg/datav/radio"),
    // 实时库存递送接口
    realInventory: () => ApiService.get("/lcg/datav/realInventory"),
    // 总量变化
    reuseAsset: () => ApiService.get("/lcg/datav/reuseAsset"),
    // 收发结存接口
    monthStats: () => ApiService.get("/lcg/datav/monthStats"),
    // 领用数量接口
    ranks: (params) => ApiService.get("/lcg/datav/ranks", params),
    // 3D大模型资产（固定资产）
    getLocation: (params) => ApiService.get("/lcg/datav/getLocation", params),
};
